<template>

    <div v-if="loading" style="height: 100%;display: flex">
        <div class="spinner-border" :style="{'color':themeTemplate.secondaryColor}"
             style="margin: auto;height: 15vmin;width: 15vmin;font-size: 6vmin" role="status">
        </div>
    </div>
  <div v-else-if="!data.length" style="height: 100%;display: flex">
      <div style="color:#EB5757;margin: auto;font-size: 1.3vw">
          {{ $t('Kiosk.errorAcquired') }}
      </div>
  </div>
  <div class="termsAndConditions" v-html="data" v-else>
  </div>
</template>
<script>
import {kioskService} from "@/_services";
import DOMPurify from 'dompurify';
export default {
    name: "LbrxPrivacyPolicy",
    data() {
        return {
            data: '',
            loading:true,
            themeTemplate:null,
        }
    },
  methods: {
    getGlobalPolicies() {
      kioskService.getGlobalPolicies()
          .then((res)=>{
            //console.log(res);
            this.data = DOMPurify.sanitize(res.policy.content);
            this.loading = false;
          })
          .catch((err)=>{
            this.loading = false;
            //console.log(err);
          })
    },
    getBusinessPolicies() {
      kioskService.getBusinessPolicies(JSON.parse(window.localStorage.getItem('business')).id)
          .then((res)=>{
            //console.log(res);
            this.data = DOMPurify.sanitize(res.policy.content);
            if(this.data) {
              this.loading = false;
            } else {
              this.getGlobalPolicies();
            }
          })
          .catch((err)=>{
            this.getGlobalPolicies();
           // console.log(err);
          })
    }
  },
    created() {
        this.themeTemplate = JSON.parse(window.localStorage.getItem('theme'));
      if(JSON.parse(window.localStorage.getItem('business')).organization_id != null) {
        kioskService.getPolicy(JSON.parse(window.localStorage.getItem('business')).organization_id)
            .then((res)=>{
              this.data = DOMPurify.sanitize(res.policy.content);
              if(this.data) {
                this.loading = false;
              } else {
                this.getBusinessPolicies();
              }
            })
            .catch((err)=>{
                this.getBusinessPolicies();
              //  console.log(err);
            })
          } else {
          this.getBusinessPolicies();
        }
    },
}
</script>
<style scoped>
.termsAndConditions{
    padding-right: 5vmin;
    padding-left:5vmin;
    font-family: 'Exo 2',serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: justify;
    color: #737070;
}
.section{
    margin-top: 2vmin;
}
</style>